// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(false);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".display-none[data-v-1015fe80]{display:none}.error-page[data-v-1015fe80]{margin-top:var(--spacer-base);position:relative;text-align:center}@media(min-width:1024px){.error-page[data-v-1015fe80]{margin-top:var(--spacer-2xl)}}.sf-link[data-v-1015fe80]{display:inline-block;margin-top:var(--spacer-base);width:auto}.sf-link[data-v-1015fe80]:focus,.sf-link[data-v-1015fe80]:hover{color:var(--c-light-variant)}", ""]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___;
